import React, { Component } from "react";
import { connect } from "react-redux";
import { createJournal } from "../../actions/journal";
import { setModule } from "../../actions/common";
import { showLoading, hideLoading } from "../../actions/loading";
import JournalDataService from "../../services/journal.service";
import CardDataService from "../../services/card.service";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import FormControlLabel from "@mui/material/FormControlLabel";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { format } from "date-fns";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import NumberFormat from "react-number-format";
import { parseNumber } from "../../helpers/common";
import ClearIcon from "@mui/icons-material/Clear";
import AddBoxIcon from "@mui/icons-material/AddBox";
import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import { AcIndexByValue, AllowCompany } from "../../helpers/common";
import FormAccount from "../account/popup";

class AddJournal extends Component {
	_isMounted = false;

	constructor(props) {
		super(props);

		this.state = {
			id: null,
			id_company: this.props.auth.idCompany,
			code: "",
			date: format(new Date(), "yyyy-MM-dd"),
			note: "",
			tax_inclusive: false,

			error: false,
			message: false,

			companies_ready: false,
			accounts_ready: false,
			jobs_ready: false,
			taxes_ready: false,

			companies: [],
			accounts: [],
			jobs: [],
			taxes: [],

			detail: [],

			total_debit: 0,
			total_credit: 0,
			total_out_of_balance: 0,
			recurring: false,
			recurring_name: "",

			formAccount: false,
			activeRowAccount: false,
			activeRowAccountId: false,
		};
	}

	componentDidMount() {
		this._isMounted = true;
		if (this._isMounted) {
			this.props.setModule("Journal");
			if (typeof this.props.match.params.id !== "undefined") {
				let id = parseNumber(this.props.match.params.id);
				let id_recurring = parseNumber(this.props.match.params.id_recurring);

				if (id > 0) {
					this.loadCurrentRow();
				}

				if (id_recurring > 0) {
					this.loadRecurringRow(id_recurring);
				}

				this.loadSelect();
			} else {
				this.newData();
				this.loadSelect();
			}
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidUpdate() {
		if (typeof this.props.match.params.id === "undefined") {
			if (this.state.id !== null) {
				this.newData();
			}
		}
	}

	loadAccounts() {
		JournalDataService.getAccounts().then((response) => {
			this.setState(
				{
					accounts_ready: true,
					accounts: response.data.Row,
				},
				function () {
					if (this.state.activeRowAccountId > 0) {
						let detail = [...this.state.detail];
						detail[this.state.activeRowAccount]["id_account"] =
							this.state.activeRowAccountId;
						this.setState({
							detail,
							activeRowAccount: false,
							activeRowAccountId: false,
						});
					}

					this.setState({
						formAccount: false,
					});
				}
			);
		});
	}

	loadSelect() {
		this.loadAccounts();

		CardDataService.getCompanies().then((response) => {
			this.setState({
				companies_ready: true,
				companies: response.data.Row,
			});
		});
		JournalDataService.getJobs().then((response) => {
			this.setState({
				jobs_ready: true,
				jobs: response.data.Row,
			});
		});
		JournalDataService.getTaxes().then((response) => {
			this.setState(
				{
					taxes_ready: true,
					taxes: response.data.Row,
				},
				function () {
					this.calculateDetail();
				}
			);
		});
	}

	loadCurrentRow() {
		this.props.showLoading();

		JournalDataService.get(this.props.match.params.id)
			.then((response) => {
				this.setState(
					{
						id: response.data.Row.id,
						id_company: response.data.Row.id_company,
						code: response.data.Row.code,
						date: response.data.Row.date,
						note: response.data.Row.note,
						tax_inclusive: response.data.Row.tax_inclusive,
						detail: response.data.Row.Detail,
					},
					function () {
						let detail = this.prepareDetail();

						this.setState({ detail }, function () {
							this.props.hideLoading();
							this.calculateDetail();
						});
					}
				);
			})
			.catch((e) => {
				let message = "";
				if (e.response === undefined) {
					message = "Request time out";
				} else {
					message = e.response.data.error;
				}

				this.setState({ message: message, error: true });
				this.props.hideLoading();
			});
	}

	loadRecurringRow(id_recurring) {
		this.props.showLoading();

		JournalDataService.code(this.props.auth.idCompany).then((resc) => {
			JournalDataService.get(id_recurring)
				.then((response) => {
					this.setState(
						{
							id: null,
							id_company: this.props.auth.idCompany,
							code: resc.data,
							date: format(new Date(), "yyyy-MM-dd"),
							note: response.data.Row.note,
							tax_inclusive: response.data.Row.tax_inclusive,
							detail: response.data.Row.Detail,
						},
						function () {
							let detail = this.prepareDetail();

							this.setState({ detail }, function () {
								this.props.hideLoading();
								this.calculateDetail();
							});
						}
					);
				})
				.catch((e) => {
					let message = "";
					if (e.response === undefined) {
						message = "Request time out";
					} else {
						message = e.response.data.error;
					}

					this.setState({ message: message, error: true });
					this.props.hideLoading();
				});
		});
	}

	prepareDetail() {
		let detail = [...this.state.detail];

		for (let i = 0; i < detail.length; i++) {
			if (detail[i]["show_input"] === true) {
				if (this.state.tax_inclusive) {
					if (detail[i]["normal_balance"] === "debit") {
						detail[i]["debit"] += detail[i]["tax_value"];
					} else {
						detail[i]["credit"] += detail[i]["tax_value"];
					}
				}
			} else {
				detail.splice(i, 1);
			}
		}
		return detail;
	}

	newData() {
		JournalDataService.code(this.props.auth.idCompany).then((response) => {
			this.setState(
				{
					id: null,
					id_company: this.props.auth.idCompany,
					code: response.data,
					date: format(new Date(), "yyyy-MM-dd"),
					note: "",
					tax_inclusive: false,

					message: false,

					detail: [],
					total_debit: 0,
					total_credit: 0,
					total_out_of_balance: 0,
					recurring: false,
					recurring_name: "",
				},
				function () {
					this.props.hideLoading();
				}
			);
		});
	}

	onChangeIdCompany(e) {
		this.setState({ id_company: e.target.value });
	}
	onChangeCode(e) {
		this.setState({ code: e.target.value });
	}
	onChangeDate(e) {
		this.setState({ date: e.target.value });
	}
	onChangeNote(e) {
		this.setState({ note: e.target.value });
	}
	onChangeTaxInclusive(e) {
		this.setState({ tax_inclusive: e.target.checked });
	}
	onChangeRecurring(e) {
		this.setState({ recurring: e.target.checked });
	}
	onChangeRecurringName(e) {
		this.setState({ recurring_name: e.target.value });
	}

	alertClose = () => {
		this.setState({ error: false });
	};

	saveJournal(e) {
		e.preventDefault();
		this.props.showLoading();

		this.setState({
			message: false,
		});

		let detail = [...this.state.detail];

		for (let i = 0; i < detail.length; i++) {
			detail[i]["debit"] = parseNumber(detail[i]["debit"]);
			detail[i]["credit"] = parseNumber(detail[i]["credit"]);
			detail[i]["id_tax"] = parseNumber(detail[i]["id_tax"]);
			detail[i]["id_job"] = parseNumber(detail[i]["id_job"]);

			if (detail[i]["debit"] > 0) {
				detail[i]["normal_balance"] = "debit";
			} else {
				detail[i]["normal_balance"] = "credit";
			}
		}

		this.setState({ detail }, function () {
			this.props
				.createJournal(
					this.state.id,
					this.state.id_company,
					this.state.code,
					this.state.date,
					this.state.note,
					this.state.tax_inclusive,
					this.state.detail,
					this.state.recurring,
					this.state.recurring_name
				)
				.then((data) => {
					this.newData();
					// this.props.history.push("/journal/form");
				})
				.catch((e) => {
					this.setState({
						message: e.response.data.error,
						error: true,
					});
					this.props.hideLoading();
				});
		});
	}

	calculateDetail() {
		let td = 0;
		let tc = 0;
		let tax = 0;
		let debit = 0;
		let credit = 0;
		this.state.detail.forEach((d) => {
			if (d.id_tax > 0) {
				if (this.state.taxes_ready) {
					let index = this.state.taxes.map((item) => item.id).indexOf(d.id_tax);
					tax = this.state.taxes[index]["field1"];
				} else tax = 0;
			} else {
				tax = 0;
			}

			debit = parseNumber(d.debit);
			credit = parseNumber(d.credit);

			//console.log(d + " = " + c);

			td += debit + debit * (tax / 100);
			tc += credit + credit * (tax / 100);
		});
		this.setState({
			total_debit: td,
			total_credit: tc,
			total_out_of_balance: td - tc,
		});
	}

	CustomPaper = (props) => {
		return <Paper {...props} sx={{ width: 450 }} />;
	};

	createUI() {
		return this.state.detail.map((e, i) => (
			<Grid key={i} container spacing={1}>
				<Grid item xs={12} sm={4}>
					<TextField
						sx={{ display: "none" }}
						type="hidden"
						id="id"
						value={e.id}
					/>

					<TextField
						sx={{ display: "none" }}
						type="hidden"
						id="id_journal"
						value={this.state.id}
					/>

					{this.state.accounts_ready && (
						<Grid container spacing={0}>
							<Grid item xs={2}>
								<IconButton
									onClick={(e) => this.addAccount(i)}
									color="primary"
									aria-label="add card"
									disabled={e.id > 0}
								>
									<AddBoxIcon />
								</IconButton>
							</Grid>
							<Grid item xs={10}>
								<Autocomplete
									id="id_account"
									name="id_account"
									fullWidth
									PaperComponent={this.CustomPaper}
									options={this.state.accounts}
									getOptionLabel={(option) => option.name}
									onChange={this.handleChange.bind(this, i)}
									value={AcIndexByValue(this.state.accounts, e.id_account)}
									readOnly={e.id > 0}
									renderInput={(params) => (
										<TextField variant="standard" {...params} label="Account" />
									)}
								/>
							</Grid>
						</Grid>
					)}
				</Grid>

				<Grid item xs={12} sm={2}>
					<FormControl
						fullWidth={true}
						variant="standard"
						sx={{ minWidth: 100 }}
					>
						<NumberFormat
							customInput={TextField}
							id="debit"
							label="Debit"
							value={e.debit}
							fullWidth
							variant="standard"
							thousandSeparator="."
							decimalSeparator=","
							decimalScale={2}
							fixedDecimalScale={true}
							autoComplete="off"
							onBlur={this.handleChange.bind(this, i)}
							onKeyDown={this.handleEnter.bind(this, i)}
						/>
					</FormControl>
				</Grid>

				<Grid item xs={12} sm={2}>
					<FormControl
						fullWidth={true}
						variant="standard"
						sx={{ minWidth: 100 }}
					>
						<NumberFormat
							customInput={TextField}
							id="credit"
							label="Credit"
							value={e.credit}
							fullWidth
							variant="standard"
							thousandSeparator="."
							decimalSeparator=","
							decimalScale={2}
							fixedDecimalScale={true}
							autoComplete="off"
							onBlur={this.handleChange.bind(this, i)}
							onKeyDown={this.handleEnter.bind(this, i)}
						/>
					</FormControl>
				</Grid>

				<Grid item xs={12} sm={1}>
					{this.state.jobs_ready && (
						<FormControl fullWidth={true} variant="standard">
							<InputLabel id="id_job_label">Job</InputLabel>
							<Select
								id="id_job"
								name="id_job"
								labelId="id_job_label"
								label="Job"
								value={e.id_job}
								onChange={this.handleChange.bind(this, i)}
							>
								<MenuItem value="0">
									<em>None</em>
								</MenuItem>
								{this.state.jobs.map((option, index) => (
									<MenuItem key={index} value={option.id}>
										{option.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					)}
				</Grid>

				<Grid item xs={12} sm={1}>
					<TextField
						id="memo"
						label="Memo"
						value={e.memo}
						onChange={this.handleChange.bind(this, i)}
						fullWidth
						variant="standard"
					/>
				</Grid>

				<Grid item xs={12} sm={1}>
					{this.state.taxes_ready && (
						<FormControl
							fullWidth={true}
							variant="standard"
							sx={{ minWidth: 100 }}
						>
							<InputLabel id="id_tax_label">Tax</InputLabel>
							<Select
								id="id_tax"
								name="id_tax"
								labelId="id_tax_label"
								label="Tax"
								value={e.id_tax}
								onChange={this.handleChange.bind(this, i)}
							>
								<MenuItem value="0">
									<em>None</em>
								</MenuItem>
								{this.state.taxes.map((option, index) => (
									<MenuItem key={index} value={option.id}>
										{option.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					)}
				</Grid>

				<Grid item xs={12} sm={1} container justifyContent="flex-end">
					<IconButton
						aria-label="Remove"
						onClick={this.removeClick.bind(this, i)}
					>
						<ClearIcon fontSize="small" />
					</IconButton>
				</Grid>

				<Grid item xs={12} sm={12}>
					<Divider sx={{ mb: 2 }} />
				</Grid>
			</Grid>
		));
	}

	addClick() {
		let newDebit = 0;
		let newCredit = 0;
		let normalBalance = "";

		if (this.state.total_out_of_balance < 0) {
			newDebit = this.state.total_out_of_balance * -1;
			normalBalance = "debit";
		} else {
			newCredit = this.state.total_out_of_balance;
			normalBalance = "credit";
		}

		this.setState(
			(prevState) => ({
				detail: [
					...prevState.detail,
					{
						id: 0,
						id_journal: this.state.id,
						id_account: 0,
						normal_balance: normalBalance,
						debit: newDebit,
						credit: newCredit,
						id_job: 0,
						memo: "",
						id_tax: 0,
					},
				],
			}),
			function () {
				this.calculateDetail();
			}
		);
	}

	handleChange(i, event, val) {
		let name;

		if (typeof event.target.id === "undefined") {
			name = event.target.name;
		} else {
			name = event.target.id;
		}

		if (name.includes("-")) {
			let tmp = name.split("-");
			name = tmp[0];
		}
		let detail = [...this.state.detail];

		if (name === "id_account") {
			if (val !== null) {
				detail[i][name] = val.id;
			}
		} else {
			detail[i][name] = event.target.value;
		}

		this.setState({ detail }, function () {
			this.calculateDetail();
		});
	}

	handleEnter(i, event) {
		if (event.key === "Enter") {
			let name;
			if (typeof event.target.id === "undefined") {
				name = event.target.name;
			} else {
				name = event.target.id;
			}

			let detail = [...this.state.detail];
			detail[i][name] = event.target.value;

			this.setState({ detail }, function () {
				this.calculateDetail();
			});
		}
	}

	removeClick(i) {
		let detail = [...this.state.detail];
		detail.splice(i, 1);
		this.setState({ detail }, function () {
			this.calculateDetail();
		});
	}

	addAccount(i) {
		this.setState({ activeRowAccount: i, formAccount: true });
	}

	formAccountClose = () => {
		this.setState({ formAccount: false });
	};

	setNewAccount(id) {
		this.setState({ activeRowAccountId: id }, function () {
			this.loadAccounts();
		});
	}

	showError(msg) {
		this.setState({
			message: msg,
			error: true,
		});
	}

	render() {
		return (
			<Box component="form" onSubmit={(e) => this.saveJournal(e)}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
							<Typography variant="h5">Journal Form</Typography>

							<Grid container spacing={3}>
								<Grid item xs={12} sm={12}>
									<Dialog
										open={this.state.error}
										onClose={this.alertClose}
										aria-labelledby="error-dialog-title"
										aria-describedby="error-dialog-description"
									>
										<DialogTitle id="error-dialog-title">Failed</DialogTitle>
										<DialogContent>
											<DialogContentText id="error-dialog-description">
												{this.state.message}
											</DialogContentText>
										</DialogContent>
										<DialogActions>
											<Button onClick={this.alertClose} autoFocus>
												Close
											</Button>
										</DialogActions>
									</Dialog>
								</Grid>

								<FormAccount
									show={this.state.formAccount}
									formAccountClose={(e) => this.formAccountClose(e)}
									setNewAccount={(id, name) => this.setNewAccount(id, name)}
									showError={(e) => this.showError(e)}
									idCompany={this.props.auth.idCompany}
									idPeriod={this.props.auth.user.id_period}
								/>

								{AllowCompany(this.props.auth.user.usergroup) && (
									<Grid item xs={12} sm={12}>
										{this.state.companies_ready && (
											<FormControl
												fullWidth={true}
												variant="standard"
												sx={{ minWidth: 100 }}
											>
												<InputLabel id="idCompany">Company</InputLabel>
												<Select
													labelId="idCompany"
													label="Company"
													value={this.state.id_company}
													onChange={(e) => this.onChangeIdCompany(e)}
												>
													{this.state.companies.map((option, index) => (
														<MenuItem key={index} value={option.id}>
															{option.name}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										)}
									</Grid>
								)}

								<Grid item xs={12} sm={6}>
									<TextField
										label="Code"
										value={this.state.code}
										onChange={(e) => this.onChangeCode(e)}
										fullWidth
										variant="standard"
									/>
								</Grid>

								<Grid item xs={12} sm={3}>
									<TextField
										label="Date"
										type="date"
										value={this.state.date}
										onChange={(e) => this.onChangeDate(e)}
										fullWidth
										variant="standard"
									/>
								</Grid>

								<Grid item xs={12} sm={6}>
									<TextField
										label="Note"
										fullWidth
										multiline
										rows={2}
										value={this.state.note}
										onChange={(e) => this.onChangeNote(e)}
									/>
								</Grid>

								<Grid item xs={12} sm={6}>
									<FormControlLabel
										control={
											<Checkbox
												checked={
													this.state.tax_inclusive === "true" ||
													this.state.tax_inclusive === true
												}
												onChange={(e) => this.onChangeTaxInclusive(e)}
											/>
										}
										label="Tax Inclusive"
									/>
								</Grid>

								<Grid item xs={12} sm={12}>
									<Divider />
								</Grid>

								<Grid item xs={12} sm={12}>
									<Typography variant="h5">List Detail</Typography>
								</Grid>

								<Grid item xs={12} sm={12}>
									{this.createUI()}

									<Button
										variant="outlined"
										size="small"
										onClick={(e) => this.addClick(e)}
									>
										Insert Row
									</Button>
								</Grid>

								<Grid item xs={12} sm={12}>
									<Divider />
								</Grid>

								<Grid item xs={12} sm={7}></Grid>

								<Grid item xs={12} sm={5}>
									<TableContainer>
										<Table>
											<TableBody>
												<TableRow>
													<TableCell width={150}>Total Debit</TableCell>
													<TableCell width={1}>:</TableCell>
													<TableCell align="right">
														<NumberFormat
															value={this.state.total_debit}
															displayType={"text"}
															thousandSeparator="."
															decimalSeparator=","
															decimalScale={2}
															fixedDecimalScale={true}
															prefix={""}
														/>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell width={150}>Total Credit</TableCell>
													<TableCell width={1}>:</TableCell>
													<TableCell align="right">
														<NumberFormat
															value={this.state.total_credit}
															displayType={"text"}
															thousandSeparator="."
															decimalSeparator=","
															decimalScale={2}
															fixedDecimalScale={true}
															prefix={""}
														/>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell width={150}>Out of Balance</TableCell>
													<TableCell width={1}>:</TableCell>
													<TableCell align="right">
														<NumberFormat
															value={this.state.total_out_of_balance}
															displayType={"text"}
															thousandSeparator="."
															decimalSeparator=","
															decimalScale={2}
															fixedDecimalScale={true}
															prefix={""}
														/>
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</TableContainer>
								</Grid>

								<Grid item xs={12} sm={12}>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.recurring === true}
												onChange={(e) => this.onChangeRecurring(e)}
											/>
										}
										label="Save as Recurring"
									/>
									{this.state.recurring && (
										<TextField
											label="Recurring Name"
											value={this.state.recurring_name}
											onChange={(e) => this.onChangeRecurringName(e)}
											fullWidth
											variant="standard"
										/>
									)}
								</Grid>

								<Grid item xs={12} sm={12}>
									<Divider />
								</Grid>

								<Grid item xs={12} sm={12}>
									<Button
										variant="contained"
										component={Link}
										to="/journal/form"
										startIcon={<ArrowBackIcon />}
										sx={{ mr: 1 }}
									>
										Cancel
									</Button>
									<Button
										type="submit"
										variant="contained"
										disabled={this.props.loading.loading}
										startIcon={<SaveIcon />}
									>
										{this.props.loading.loading && (
											<span>
												<span className="spinner-border spinner-border-sm"></span>
												&nbsp;
											</span>
										)}
										<span>
											{" "}
											{this.props.loading.loading ? "Please Wait" : "Save"}
										</span>
									</Button>
								</Grid>
							</Grid>
						</Paper>
					</Grid>
				</Grid>
			</Box>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		loading: state.loading,
	};
};

export default connect(mapStateToProps, {
	createJournal,
	showLoading,
	hideLoading,
	setModule,
})(AddJournal);
